import styled from '@emotion/styled'

export const MainContainer = styled.div``
